export default __webpack_public_path__ + "static/media/submit.f2aa02f1.svg";